import UtilityMixin from "../../../utility/UtilityMixin";
import moment from "moment";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	mixins: [UtilityMixin],
	data() {
		return {
			pathResourcePazienteConsensi: "/pazienticonsensi",
			pathResourcePazienteConsensiStati: "/pazienticonsensistatistorico",
			pazienteConsenso: { idPaziente: null, idConsenso: null, nomeConsenso: null },
			pazienteConsensiItems: [],
			pazienteConsensiFiltro: {},
			pazienteConsensiRows: 0,
			pazienteConsensiFields: [
				{
					label: "",
					key: "index",
					thStyle: "width: 3rem",
				},

				{
					label: "Data Ora",
					key: "updateDate",
					formatter: (value) => {
						return moment(value).format("DD/MM/YYYY HH:mm:ss");
					},
					thStyle: "width: 15rem",
				},
				{
					label: "Tipologia",
					key: "tipologia",
					thStyle: "width: 15rem",
				},
				{
					label: "Consenso",
					key: "nomeConsenso",
				},

				{
					label: "Stato",
					key: "statoAttuale",
					thStyle: "width: 15rem",
				},
				{
					label: "",
					key: "actions",
					class: "sa-table-column-action-double",
				},
			],
		};
	},
	methods: {
		pazienteConsensoNew() {
			this.pazienteConsenso = { idPaziente: null, idConsenso: null, nomeConsenso: null };
		},
		// pazienteConsensoSave() {
		// 	this.saveResource(this.pathResourcePazienteConsensi, this.pazienteConsenso, this.pazienteConsensoSaveSuccess, null);
		// },
		// pazienteConsensoSaveSuccess(response) {
		// 	this.pazienteConsenso = response.data.data;
		// 	this.pazienteConsensiLoadData();
		// },
		pazienteConsensiLoadData() {
			this.loadDataResources(this.pathResourcePazienteConsensi, this.pazienteConsensiFiltro, this.pazienteConsensiLoadDataSuccess, null);
		},
		pazienteConsensiLoadDataSuccess(response) {
			this.pazienteConsensiItems = [];
			this.pazienteConsensiItems = response.data.data.list;
			this.pazienteConsensiRows = response.data.data.recordsNumber;
			this.$emit("afterLoadData");
			this.closeShowModalLoading();
		},
		pazienteConsensoCambiaStato(idPazienteConsenso, stato) {
			let me = this;
			this.$bvModal
				.msgBoxConfirm("Assicurarsi che il consenso sia stato firmato prima di proseguire ", {
					title: "ATTENZIONE!",
					headerClass: "bg-danger text-white",
					buttonSize: "sm",
					okVariant: "secondary",
					cancelVariant: "danger",
					okTitle: "SI",
					cancelTitle: "NO",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true,
				})
				.then((value) => {
					if (value) {
						me.openShowModalLoading();
						let jsonStato = { idPazienteConsenso: idPazienteConsenso, stato: stato, note: "Consenso firmato in modalità cartacea" };
						this.saveResource(this.pathResourcePazienteConsensiStati, jsonStato, this.pazienteConsensoCambiaStatoSuccess, null);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		pazienteConsensoCambiaStatoSuccess() {
			this.pazienteConsensiLoadData();
			this.closeShowModalLoading();
		},
	},
};
